import { createSignal, splitProps } from "solid-js";
import { Select } from "~/components/Forms/Fields/Base/Select";

import type {
  InputOption,
  SchemaOptions,
  SelectPropsWithOptionalOptions,
  ValidationFunc,
} from "~/components/Forms/Fields/Base/InputTypesProps";
import { picklist, safeParse } from "valibot";
import ValidationErrors from "./Base/ValidationErrors";

import IconSchedule from "~/img/icons/push/schedule.svg";

const LABEL = "Quel créneau horaire ?";
const HELP = undefined;
const IS_REQUIRED_BY_DEFAULT = false;

export const availableOptions: InputOption[] = [
  {
    label: "entre 8 et 10 heures",
    value: "8_10",
    name: "8_10",
  },
  {
    label: "entre 10 et 12 heures",
    value: "10_12",
    name: "10_12",
  },
  {
    label: "entre 12 et 14 heures",
    value: "12_14",
    name: "12_14",
  },
  {
    label: "entre 14 et 16 heures",
    value: "14_16",
    name: "14_16",
  },
  {
    label: "entre 16 et 18 heures",
    value: "16_18",
    name: "16_18",
  },
  {
    label: "entre 18 et 20 heures",
    value: "18_20",
    name: "18_20",
  },
] as const;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function HourSchema(options?: SchemaOptions) {
  return {
    hour: picklist(
      availableOptions.map((o) => o.value),
      "Veuillez sélectionner une heure.",
    ),
  };
}

export function Hour(props: SelectPropsWithOptionalOptions) {
  const [local, others] = splitProps(props, [
    "label",
    "help",
    "required",
    "options",
  ]);
  const [validationErrors, setValidationErrors] = createSignal<string[]>([]);

  const validate: ValidationFunc = (input) => {
    const ret = safeParse(HourSchema().hour, input);
    ret.success
      ? setValidationErrors([])
      : setValidationErrors(ret.issues.map((issue) => issue.message));
  };

  return (
    <>
      <div class={`form-item-${props.name}`}>
        <Select
          label={local.label || LABEL}
          help={local.help || HELP}
          /* if options are given as props skip field validation */
          validateFn={local.options ? undefined : validate}
          required={
            local.required !== undefined
              ? local.required
              : IS_REQUIRED_BY_DEFAULT
          }
          options={local.options ?? availableOptions}
          {...others}
          prependIcon={<IconSchedule />}
        />
        <ValidationErrors
          errors={validationErrors()}
          field={props.name}
          withPrependIcon
        />
      </div>
    </>
  );
}
